// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dcd70f2f","453":"cf66add8","455":"978e973e"}[chunkId] + ".chunk.js";
};